import React from 'react'
import {request} from '../../helpers/request.js';
import CurrencyComponent from './CurrencyComponent'
import {makeGrids} from '../../helpers/makeGrids'
import {formatMoney} from '../../helpers/formatMoney'
import {ListGroup, ListGroupItem, Alert, Input, Panel} from 'react-bootstrap'
import {t} from '../../helpers/translate'
import _ from 'lodash'
import Icon from 'react-fa'
import accounting from 'accounting'
import PaymentHistoryComponent from './PaymentHistoryComponent'
let config = require('config');

class RefundComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      processingRefund: false,
      refundSuccessful: false,
      refundErrors: null,
      remainingRefund: 0,
      refundAmounts:[]
    }
  }

  componentWillMount(){
    const refundAmounts = [];
    this.props.quoteResponseData.additional_data[this.props.provider].map((charge) => {
      refundAmounts.push({amount:0, transaction_fee:0});
    })
    this.setState({
      refundAmounts: [...this.state.refundAmounts, ...refundAmounts],
      remainingRefund: this.props.quoteResponseData.premium_difference
    })
  }

  processRefund() {
    const charges = [];
    this.props.quoteResponseData.additional_data[this.props.provider].map((charge, index) => {
      if((Number(this.state.refundAmounts[index].amount) + Number(this.state.refundAmounts[index].transaction_fee)) > 0){
        charges.push({amount: this.state.refundAmounts[index].amount, transaction_fee: this.state.refundAmounts[index].transaction_fee, charge_id: charge.charge_id});
      }
    })

    const data = {
      payment_provider: this.props.provider,
      additional_data: {
        stripe: charges
      }
    };

    this.setState({
        processingRefund: true,
        refundErrors: null
      }, () => {
        request(`${config.default.api}/premium/charge/${this.props.source}/${this.props.quoteResponseData.id}`, 'POST', data, (response, statusCode) => {
          if (statusCode === 200) {
            this.setState({
              refundSuccessful: true
            }, this.props.onRefundSuccess)
          } else if (statusCode == 400) {
            this.setState({
              refundSuccessful: false,
              refundErrors: response.messages
            })
          }
          this.setState({
            processingRefund: false
          })
        });
      }
    )
  }

  cancelPayment() {
    this.setState({
      processingRefund: false
    }, this.props.onCancel);
  }

  updateRefund(evt, index, type)
  {
    const val = evt.target.value

    this.setState(function(previousState,currentProps){
      previousState.remainingRefund = (this.state.remainingRefund - this.state.refundAmounts[index][type] + (parseFloat(val) || 0)).toFixed(2),
      previousState.refundAmounts[index][type] = val
    })
  }

  createRefundSections(){
    return(
      this.props.quoteResponseData.additional_data[this.props.provider].map((charge, index) =>
        <ListGroupItem key={index}>{
          makeGrids(3,
            [
              {
                title: `${t('Payment')} # ${index + 1}`,
                body: null
              },
              {
                title: t('Cardholder Name'),
                body: charge.cardholder_name || 'N/A'
              },
              {
                title: t('Charge Date'),
                body: charge.charge_date
              },
              {
                title: t('Brand'),
                body: charge.brand
              },
              {
                title: `${t('Card Number')} ${t('Last 4')}`,
                body: charge.last4
              },
              {
                title: t('Maximum Refund'),
                body: accounting.formatMoney(charge.max_amount, config.default.currency_format)
              }
            ].map((item, index) => <div key={index}>
              <div className="form-group-md">
                <label className="text-uppercase">{item.title}</label>
                <div className="form-control-static">{item.body}</div>
              </div>
            </div>).concat(
              <div>
                <label className="text-uppercase">{t('Refund Amount')}</label>
                <Input data-charge-id={charge.charge_id}
                  data-charge-type='amount' addonBefore="$" addonAfter={this.props.quoteResponseData.currency} type="text"
                  onChange={evt => this.updateRefund(evt, index, 'amount')}
                  value={this.state.refundAmounts[index].amount}
                  disabled={charge.max_amount == 0 ? true : false}/>
              </div>
            ).concat(
              <div>
                <label className="text-uppercase">{t('Transaction Fee')}</label>
                <Input data-charge-id={charge.charge_id}
                  data-charge-type={'fee'} addonBefore="$" addonAfter={this.props.quoteResponseData.currency} type="text"
                  onChange={evt => this.updateRefund(evt, index, 'transaction_fee')}
                  value={this.state.refundAmounts[index].transaction_fee}
                  disabled={charge.max_amount == 0 ? true : false}/>
              </div>
            )
          )
        }
        </ListGroupItem>
      )
    )
  }

  showRemainingAmount () {
    return (
      (() => {
        if (this.props.quoteResponseData.premium_difference < 0) {
          return <div>
            <label className="text-uppercase remaining-amount">{t('Remaining Amount')}</label>
            <span>{formatMoney(this.state.remainingRefund, this.props.quoteResponseData.currency)}</span>
          </div>
        }
      })()
    )
  }

  showRefundErrors () {
    return (
        (() => {
          if (this.state.refundErrors) {
            return <Alert bsStyle="danger">
              {this.state.refundErrors.map((message) => <p>{message}</p>)}
            </Alert>
          }
        })()
    )
  }

  render() {
    return (
      <div><label className="text-uppercase">{t('Payment History')}</label>
        <div ref="refundForm">
          <Panel>
            <ListGroup fill>
              {this.createRefundSections()}
            </ListGroup>
            {this.showRemainingAmount()}
          </Panel>
          {this.showRefundErrors()}
          <div className="btn-group pull-left">
            <button className="btn button-primary"
                onClick={this.cancelPayment.bind(this)}
                disabled={this.state.processingPayment || this.state.paymentSuccessful || !this.props.quoteResponseData}>
              {t('Cancel Refund')}
            </button>
            <button className="btn button-secondary"
                onClick={this.processRefund.bind(this)}
                disabled={this.state.processingRefund || this.state.refundSuccessful || !this.props.quoteResponseData}
                bsStyle={this.state.refundSuccessful ? 'success' : 'primary'}>
              {this.state.processingRefund && !this.state.refundSuccessful ? <Icon spin name="spinner"/> : null}
              {' '}
              {this.state.refundSuccessful ?
                [<Icon name="check"/>, <span>{ t('Refund Successful')}</span>] : t('Process Refund')}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

RefundComponent.displayName = 'RefundComponent';
export default RefundComponent;



// WEBPACK FOOTER //
// ./src/components/common/StripeRefundComponent.js